import React, { useEffect } from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';

const Counter = ({ value }) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  
  useEffect(() => {
    const controls = animate(count, parseFloat(value) || 0, { duration: 2, ease: "easeOut" });
    return controls.stop;
  }, [value, count]);

  return <motion.span>{rounded}</motion.span>;
};

const Stats = () => {
  const stats = [
    { label: "Happy Clients", val: "15000", suffix: "+" },
    { label: "Expert Doctors", val: "12", suffix: "" },
    { label: "Years Experience", val: "25", suffix: "" },
    { label: "Luxury Styles", val: "2000", suffix: "+" }
  ];

  return (
    <section id="stats" className="py-20 lg:py-24 bg-white border-y border-slate-50 font-poppins relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 items-center">
          {stats.map((stat, i) => (
            <motion.div 
              key={i} 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.8 }}
              className={`text-center relative ${i !== stats.length - 1 ? 'lg:border-r lg:border-slate-100' : ''}`}
            >
              <div className="mb-2">
                <p className="text-4xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-syana-blue-600 via-slate-900 to-syana-blue-600 animate-wave-gradient tracking-tight leading-none">
                  <Counter value={stat.val} />{stat.suffix}
                </p>
              </div>
              <p className="text-slate-400 font-bold uppercase tracking-[0.2em] text-[10px] lg:text-xs">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
